<template>
  <div>
    <button
      :id="`collapsible-title-${uuid || slugify(title)}`"
      :aria-expanded="!isCollapsed"
      class="flex w-full items-center gap-x-2 text-left"
      :class="additionalClasses"
      type="button"
      :aria-controls="`collapsible-content-${uuid || slugify(title)}`"
      @click="toggle"
    >
      <FimPicture
        v-if="icon"
        provider="storyblok"
        layout="raw"
        :src="icon"
        :alt="title"
        class="size-6 shrink-0 object-contain"
        loading="lazy"
        width="24"
        height="24"
      />
      <span class="grow">{{ title }}</span>
      <component
        :is="isCollapsed ? IconFielmannChevronDown : IconFielmannChevronUp"
        class="size-6 shrink-0"
        aria-hidden="true"
      />
    </button>
    <div
      :id="`collapsible-content-${uuid || slugify(title)}`"
      class="overflow-hidden text-xs"
      :class="{ 'h-0': isCollapsed }"
      :aria-labelledby="`collapsible-title-${uuid || slugify(title)}`"
    >
      <div class="pb-2">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { slugify } from '@scayle/storefront-nuxt'
import { IconFielmannChevronDown, IconFielmannChevronUp } from '#components' // explicit

const props = defineProps({
  title: {
    type: String as PropType<string>,
    required: true,
  },
  icon: {
    type: String as PropType<string>,
    default: undefined,
  },
  opened: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  additionalClasses: {
    type: String as PropType<string>,
    default: '',
  },
  uuid: {
    type: String as PropType<string>,
    default: '',
  },
})

const isCollapsed = ref(!props.opened)
const toggle = () => {
  isCollapsed.value = !isCollapsed.value
}
</script>
